import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

const resources = {
  en: {
    translation: {
      'Homeviewernav': 'Home',
      'Reports': 'Reports',
      'AboutUs': 'About Us',
      'Support': 'Support',
      'Login': 'Login',
      'Logout': 'Logout',
      'Profile': 'Profile',
      hero: {
        title: 'RQM Ai',
        subtitle: 'Advanced Data Analytics & Visualization',
        tagline: 'Interactive charts, custom reports, and actionable insights to drive your business decisions',
        viewSampleButton: 'View Sample Reports',
        dataSolutionsButton: 'Data Solutions'
      },

      stats: {
        dataPointsAnalyzed: 'Data Points Analyzed Daily',
        customReportsGenerated: 'Custom Reports Generated',
        chartTypesAvailable: 'Chart Types Available',
        platformUptime: 'Platform Uptime'
      },

      Platform: {
        Platform: 'Raq Platform',
        Paragraph: `Raqm Platform is an advanced data analytics platform developed to be the intelligent partner in decision-making by enabling organizations to transform
        scattered data into actionable insights that enhance operational performance and support strategic directions.In a world where data is accelerating from multiple sources,
        Raqm provides an integrated solution to connect these sources, cleanse them, and analyze them using modern methods based on artificial intelligence and data science, with 
        the aim of extracting their true value.`
      },


      Why: {
        WhyRqm: "Why Rqm",
        WhyDesc: `Because we don’t just collect data—we transform it into a strategic asset. We believe that data is not merely numbers but an opportunity to build a more 
        efficient and intelligent future. We provide you with the tools and expertise that open new horizons in understanding and guiding your business.`
      },

      mission: {
        title: 'What we offer?',
        paragraph1: `Data Integration: Seamless and secure connection with multiple data sources such as open data connectors, social media platforms, and others.`,
        paragraph2: `Intelligent Analysis: Leveraging advanced analytical models to generate precise insights and future forecasts. Interactive Reports: Dashboards and visual designs that enable users to easily understand data and make instant decisions.`,
        paragraph3: `Decision Support: Providing real-time Key Performance Indicators (KPIs) to enhance the quality of decision-making at every moment.`,
        imageAlt: 'Example of an interactive dashboard'
      },

      "ourMessage": {
        "title": "Our Message",
        "paragraph1": "Harnessing technology and data to support the digital transformation journey of organizations through advanced analytics tools and interactive reports tailored to meet the needs of every management level — from daily operations to strategic planning."
      },

      "ourVision": {
        "title": "Our Vision",
        "paragraph": "To be the leading platform empowering business leaders to make well-informed decisions backed by precise data and deep analytics—driving organizational excellence and long-term sustainability."
      },

      features: {
        title: 'Our Solutions',
        interactiveChartLibrary: {
          title: 'Interactive Chart Library',
          description: 'Choose from over 50 customizable chart types including line graphs, heatmaps, scatter plots, and geographical maps for clear data visualization.'
        },
        predictiveAnalytics: {
          title: 'Predictive Analytics',
          description: 'Utilize ML algorithms to forecast trends, identify outliers, and receive automated insights on your data patterns and anomalies.'
        },
        customReportBuilder: {
          title: 'Custom Report Builder',
          description: 'Create branded reports with drag-and-drop simplicity. Combine charts, tables, and narratives into presentation-ready documents.'
        },
        dataIntegrationHub: {
          title: 'Data Integration Hub',
          description: 'Connect to multiple data sources including SQL databases, spreadsheets, CRMs, and cloud storage to create unified analytical views.'
        }
      },

      journey: {
        title: 'Our Journey',
        events: {
          event2020: {
            year: '2020',
            title: 'First Visualization Engine',
            description: 'Launched our core charting library with 20 interactive visualization types.'
          },
          event2021: {
            year: '2021',
            title: 'Report Builder Released',
            description: 'Introduced our drag-and-drop report creation system with template library.'
          },
          event2022: {
            year: '2022',
            title: 'Advanced Analytics Integration',
            description: 'Added statistical analysis tools and automated insight generation to all charts.'
          },
          event2023: {
            year: '2023',
            title: 'Real-time Dashboard System',
            description: 'Developed live-updating dashboards with cross-filtering and drill-down capabilities.'
          },
          event2024: {
            year: '2024',
            title: 'Data Integration Platform',
            description: 'Released our universal connector system supporting 50+ data sources with automated refreshing.'
          }
        }
      },

      team: {
        title: 'Meet Our Team',
        intro: 'Our diverse team of experts combines deep technical knowledge with industry expertise.',
        members: {
          member1: {
            name: 'Raqm Ai',
            role: 'Chief Data Officer',
            bio: 'Data visualization expert with 15 years of experience in analytical reporting systems.'
          },
          member2: {
            name: 'Eman',
            role: 'Head of Analytics',
            bio: 'Statistics expert specializing in predictive modeling and trend analysis.'
          },
          member3: {
            name: 'Ziad ahmed',
            role: 'Visualization Designer',
            bio: 'Chart and dashboard specialist focused on making data accessible through visual storytelling.'
          },
          member4: {
            name: 'Ahmedmohamed',
            role: 'Data Integration Lead',
            bio: 'Expert in connecting diverse data sources and building unified analytical views.'
          }
        }
      },

      values: {
        title: 'Our Core Values',
        dataAccuracy: {
          title: 'Data Accuracy',
          description: 'We prioritize precision and reliability in every chart, report, and insight we deliver.'
        },
        visualClarity: {
          title: 'Visual Clarity',
          description: 'We transform complex data into clear, intuitive visualizations that anyone can understand.'
        },
        customization: {
          title: 'Customization',
          description: 'We build solutions tailored to your specific data needs and business objectives.'
        },
        actionableInsights: {
          title: 'Actionable Insights',
          description: 'We focus on delivering insights that drive meaningful business decisions and outcomes.'
        }
      },

      testimonials: {
        title: "Our Clients",
        quote: "We serve institutions across various sectors, from government entities to private companies, who strive to elevate transparency, improve performance, and strengthen competitiveness through data-driven decisions."
      },


      cta: {
        title: 'Ready to transform your data experience?',
        subtitle: 'Start your journey to data-driven decision making today.',
        primaryButton: 'Create Your First Report',
        secondaryButton: 'Explore Chart Gallery'
      },
      herohome: {
        greeting: 'Hello',
        introTitle: 'From data to decisions...',
        intro: 'We create the future of business with intelligence and analysis.',
      },
      reports: {
        mostViewed: 'Most Viewed Reports',
        latest: 'Latest Reports',
        Details: 'Details',
        reportName: 'Report Name:',
        reportDate: 'Report Date:',
        detailsButton: 'Details',
        analyst: 'Analyst',
        SeeMore: "See More"
      },
      'ContactUs': 'Contact Us',
      'Name': 'Name',
      'Email': 'Email',
      'Message': 'Message',
      'Send': 'Send',
      'PleaseEnterYourName': 'Please enter your name',
      'PleaseEnterYourEmail': 'Please enter your email',
      'InvalidEmail': 'Invalid email',
      'PleaseEnterYourMessage': 'Please enter your message',
      'WeWillReachOutToYouSoon': 'We will reach out to you very soon',
      'FailedToSendMessage': 'Failed to send message. Please try again.',
      alerts: {
        Link: "This report is only available to registered members. Please log in or create an account.",
        "problem": "There is a problem!",
        "allowed": "This account is not allowed to reach this report"
      },
      "Previous": "Previous",
      "Next": "Next"
    }
  },
  ar: {
    translation: {
      'Homeviewernav': 'الرئيسيه',
      'Reports': 'التقارير',
      'AboutUs': 'من نحن',
      'Support': 'الدعم الفني',
      'Login': 'تسجيل الدخول',
      'Logout': 'تسجيل الخروج',
      'Profile': 'الحساب الشخصي',
      hero: {
        title: 'Rqm Ai',
        subtitle: 'تحليلات البيانات المتقدمة والتصوير',
        tagline: 'رسوم بيانية تفاعلية وتقارير مخصصة ورؤى قابلة للتنفيذ لتوجيه قرارات عملك',
        viewSampleButton: 'عرض التقارير النموذجية',
        dataSolutionsButton: 'حلول البيانات'
      },

      stats: {
        dataPointsAnalyzed: 'نقاط البيانات المحللة يوميًا',
        customReportsGenerated: 'التقارير المخصصة المنشأة',
        chartTypesAvailable: 'أنواع الرسوم البيانية المتاحة',
        platformUptime: 'وقت تشغيل المنصة'
      },

      Platform: {
        Platform: 'منصة رقم',
        Paragraph: `منصة رقم هي منصة متقدمة لتحليل البيانات تم تطويرها لتكون الشريك الذكي في صناعة القرار
        من خلال تمكين المؤسسات من تحويل البيانات المتفرقة إلى رؤى قابلة للتنفيذ تعزز الأداء التشغيلي وتدعم التوجهات الاستراتيجية في عالم تتسارع فيه البيانات من مصادر متعددة
        ، نوفر في “رقم” حلاً متكاملاً لربط هذه المصادر ، وتنقيتها، وتحليلها بأساليب حديثة تعتمد على الذكاء الاصطناعي وعلوم البيانات، بهدف استخراج القيمة الحقيقية منها`
      },


      Why: {
        WhyRqm: `لماذا رقم؟`,
        WhyDesc: `لأننا لا نكتفي بجمع البيانات، بل نحولها إلى أصل إستراتيجي.
        نحن نؤمن أن البيانات ليست مجرد أرقام، بل فرصة لبناء مستقبل أكثر كفاءة وذكاء. نقدم لك الأدوات والخبرات التي تفتح آفاقًا جديدة في فهم عملك وتوجيهه.`
      },

      mission: {
        title: 'ماذا نقدم ؟',
        paragraph1: `تكامل البيانات: ربط سلس وآمن مع مصادر البيانات المتعددة مثل ،موصلات البيانات المفتوحة، منصات التواصل الإجتماعي وغيرها.`,
        paragraph2: `تحليل ذكي: استخدام نماذج تحليل متقدمة لتوليد رؤى دقيقة وتوقّعات مستقبلية.تقارير تفاعلية: لوحات معلومات وتصاميم بصرية تتيح للمستخدمين فهم البيانات بسهولة واتخاذ قرارات فورية.`,
        paragraph3: `دعم القرار: تقديم مؤشرات قياس الأداء (KPIs) في الوقت الحقيقي لتعزيز جودة القرار في كل لحظة.`,
        imageAlt: 'مثال للوحة معلومات تفاعلية'
      },

      "ourMessage": {
        "title": "رسالتنا",
        "paragraph1": "تسخير التكنولوجيا والبيانات لدعم رحلة التحول الرقمي للمؤسسات من خلال أدوات تحليل متقدمة وتقارير تفاعلية تواكب احتياجات كل مستوى إداري، من العمليات اليومية إلى التخطيط الاستراتيجي.",
      },

      "ourVision": {
        "title": "رؤيتنا",
        "paragraph": "أن نكون المنصة الرائدة في تمكين قادة الأعمال من اتخاذ قرارات مدروسة، مستندة إلى بيانات دقيقة وتحليلات عميقة، تسهم في تحقيق التميز المؤسسي والاستدامة."
      },

      features: {
        title: 'حلولنا',
        interactiveChartLibrary: {
          title: 'مكتبة الرسوم البيانية التفاعلية',
          description: 'اختر من بين أكثر من 50 نوعًا من الرسوم البيانية القابلة للتخصيص بما في ذلك الرسوم البيانية الخطية وخرائط الحرارة والرسوم البيانية المبعثرة والخرائط الجغرافية للحصول على تصور واضح للبيانات.'
        },
        predictiveAnalytics: {
          title: 'التحليلات التنبؤية',
          description: 'استخدم خوارزميات التعلم الآلي للتنبؤ بالاتجاهات وتحديد القيم الشاذة والحصول على رؤى آلية حول أنماط البيانات والشذوذ.'
        },
        customReportBuilder: {
          title: 'أداة إنشاء التقارير المخصصة',
          description: 'إنشاء تقارير ذات علامات تجارية ببساطة السحب والإفلات. دمج الرسوم البيانية والجداول والسرد في مستندات جاهزة للعرض.'
        },
        dataIntegrationHub: {
          title: 'مركز تكامل البيانات',
          description: 'الاتصال بمصادر بيانات متعددة بما في ذلك قواعد بيانات SQL وجداول البيانات وأنظمة إدارة علاقات العملاء والتخزين السحابي لإنشاء عروض تحليلية موحدة.'
        }
      },

      journey: {
        title: 'رحلتنا',
        events: {
          event2020: {
            year: '2020',
            title: 'أول محرك تصوير',
            description: 'أطلقنا مكتبة الرسوم البيانية الأساسية مع 20 نوعًا من التصورات التفاعلية.'
          },
          event2021: {
            year: '2021',
            title: 'إصدار أداة إنشاء التقارير',
            description: 'قدمنا نظام إنشاء التقارير بالسحب والإفلات مع مكتبة القوالب.'
          },
          event2022: {
            year: '2022',
            title: 'تكامل التحليلات المتقدمة',
            description: 'أضفنا أدوات التحليل الإحصائي وتوليد الرؤى الآلية لجميع الرسوم البيانية.'
          },
          event2023: {
            year: '2023',
            title: 'نظام لوحة المعلومات في الوقت الفعلي',
            description: 'طورنا لوحات معلومات تحديث مباشر مع إمكانات التصفية المتقاطعة والتفصيل.'
          },
          event2024: {
            year: '2024',
            title: 'منصة تكامل البيانات',
            description: 'أطلقنا نظام الاتصال العالمي الذي يدعم أكثر من 50 مصدرًا للبيانات مع تحديث تلقائي.'
          }
        }
      },

      team: {
        title: 'تعرف على فريقنا',
        intro: 'يجمع فريقنا المتنوع من الخبراء بين المعرفة التقنية العميقة والخبرة في المجال.',
        members: {
          member1: {
            name: 'رقم',
            role: 'رئيس قسم البيانات',
            bio: 'خبير في تصوير البيانات مع 15 عامًا من الخبرة في أنظمة التقارير التحليلية.'
          },
          member2: {
            name: 'إيمان',
            role: 'رئيس التحليلات',
            bio: 'خبير إحصائي متخصص في النمذجة التنبؤية وتحليل الاتجاهات.'
          },
          member3: {
            name: 'زياد أحمد',
            role: 'مصمم التصوير',
            bio: 'متخصص في الرسوم البيانية ولوحات المعلومات يركز على جعل البيانات في متناول الجميع من خلال رواية القصص المرئية.'
          },
          member4: {
            name: 'أحمد محمد',
            role: 'مسؤول تكامل البيانات',
            bio: 'خبير في ربط مصادر البيانات المتنوعة وبناء وجهات نظر تحليلية موحدة.'
          }
        }
      },

      values: {
        title: 'قيمنا الأساسية',
        dataAccuracy: {
          title: 'دقة البيانات',
          description: 'نحن نعطي الأولوية للدقة والموثوقية في كل رسم بياني وتقرير ورؤية نقدمها.'
        },
        visualClarity: {
          title: 'الوضوح البصري',
          description: 'نحن نحول البيانات المعقدة إلى تصورات واضحة وبديهية يمكن لأي شخص فهمها.'
        },
        customization: {
          title: 'التخصيص',
          description: 'نحن نبني حلولًا مصممة خصيصًا لاحتياجات البيانات الخاصة بك وأهداف عملك.'
        },
        actionableInsights: {
          title: 'رؤى قابلة للتنفيذ',
          description: 'نحن نركز على تقديم رؤى تدفع قرارات الأعمال الهادفة والنتائج.'
        }
      },

      testimonials: {
        title: "عملاؤنا",
        quote: 'نخدم مؤسسات في مختلف القطاعات، من القطاع الحكومي إلى الشركات الخاصة، ممن يسعون إلى رفع مستوى الشفافية وتحسين الأداء وتعزيز القدرة على المنافسة من خلال قرارات مبنية على البيانات.'
      },

      cta: {
        title: 'هل أنت مستعد لتحويل تجربة البيانات الخاصة بك؟',
        subtitle: 'ابدأ رحلتك نحو اتخاذ القرارات المستندة إلى البيانات اليوم.',
        primaryButton: 'أنشئ تقريرك الأول',
        secondaryButton: 'استكشف معرض التقارير'
      },
      herohome: {
        greeting: 'مرحباً',
        introTitle: "من البيانات إلى القرار ...",
        intro: 'نصنع مستقبل الأعمال بالذكاء والتحليل'
      },

      reports: {
        mostViewed: 'التقارير الأكثر مشاهدة',
        latest: 'أحدث التقارير',
        Details: 'عرض التقرير',
        reportName: 'اسم التقرير:',
        reportDate: 'تاريخ التقرير:',
        detailsButton: 'التفاصيل',
        analyst: 'المحلل',
        SeeMore: "قراءة المزيد"
      },
      'ContactUs': 'اتصل بنا',
      'Name': 'الاسم',
      'Email': 'البريد الإلكتروني',
      'Message': 'الرسالة',
      'Send': 'إرسال',
      'PleaseEnterYourName': 'الرجاء إدخال اسمك',
      'PleaseEnterYourEmail': 'الرجاء إدخال بريدك الإلكتروني',
      'InvalidEmail': 'بريد إلكتروني غير صالح',
      'PleaseEnterYourMessage': 'الرجاء إدخال رسالتك',
      'WeWillReachOutToYouSoon': 'سنتواصل معك قريبًا',
      'FailedToSendMessage': 'فشل في إرسال الرسالة. يرجى المحاولة مرة أخرى.',
      alerts: {
        Link: "هذا التقرير متاح فقط للأعضاء المسجلين. يرجى تسجيل الدخول أو إنشاء حساب",
        "problem": "حدث مشكلة",
        "allowed": "ليس مسموح لهذا الحساب بالوصول إلى هذا التقرير",
      },
      "Previous": "السابق",
      "Next": "التالي"
    }
  }

}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  })

export default i18n
